import { salesProspectPath } from '@/lib/prospects-model';

/**
 * GHL custom / hidden field key for the staff Client Prospect posture URL
 * (calendar widget prefill on survey → booking handoff).
 */
export const GHL_HARRY_POSTURE_ANALYSIS_URL_QUERY_KEY = 'harry_posture_analysis_url';

/** Hidden TEXT `contact.harry_lead_source` on calendar form QY4D2w0YD3D3tmAiqoAb. */
export const GHL_HARRY_LEAD_SOURCE_QUERY_KEY = 'harry_lead_source';
/** Named Query Key alias configured as `source`. */
export const GHL_HARRY_LEAD_SOURCE_QUERY_KEY_ALIAS = 'source';
export const GHL_HARRY_LEAD_SOURCE = 'hArry - harryposture.com';

export function applyGhlHarryLeadSource(setParam: (key: string, value: string) => void): void {
  setParam(GHL_HARRY_LEAD_SOURCE_QUERY_KEY, GHL_HARRY_LEAD_SOURCE);
  setParam(GHL_HARRY_LEAD_SOURCE_QUERY_KEY_ALIAS, GHL_HARRY_LEAD_SOURCE);
}

const STAFF_PROSPECT_PREFIX = '/sales/prospects';

export function isStaffProspectPath(pathname: string): boolean {
  return pathname === STAFF_PROSPECT_PREFIX || pathname.startsWith(`${STAFF_PROSPECT_PREFIX}/`);
}

export function salesProspectAbsoluteUrl(origin: string, prospectId: string): string {
  const base = origin.replace(/\/+$/, '');
  return `${base}${salesProspectPath(prospectId)}`;
}

export function buildGhlHarryPostureAnalysisUrlQuery(
  origin: string,
  prospectId: string,
): URLSearchParams {
  const params = new URLSearchParams();
  params.set(
    GHL_HARRY_POSTURE_ANALYSIS_URL_QUERY_KEY,
    salesProspectAbsoluteUrl(origin, prospectId),
  );
  applyGhlHarryLeadSource((key, value) => params.set(key, value));
  return params;
}

export function ghlAttachQueryIsSafe(params: URLSearchParams): boolean {
  if (params.has('harry_sa_session')) return false;
  if (params.get('download') === '1') return false;
  const url = params.get(GHL_HARRY_POSTURE_ANALYSIS_URL_QUERY_KEY);
  if (!url) return false;
  return isStaffProspectPath(new URL(url).pathname);
}

export function staffProspectLoginHref(pathname: string, search = ''): string {
  if (!isStaffProspectPath(pathname)) {
    return '/';
  }
  const query = !search || search.startsWith('?') ? search : `?${search}`;
  return `/login?returnTo=${encodeURIComponent(`${pathname}${query}`)}`;
}
